import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { ImageElementSettings } from './image-control-model';
import produce from 'immer';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { cloneDeep } from 'lodash-es';
@Component({
    selector: 'topo-template-image-element',
    templateUrl: './image-control.component.html',
    styleUrls: ['./image-control.component.scss'],
    standalone: false
})
export class TemplateDesignImageElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    } else if (this.editMode === true && !!value) {
      this.loadSettings();
    }
  }
  _culture: string;

  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  @ViewChild('fileUpload') uploadFileControl: ElementRef<HTMLElement>;
  @ViewChild('image') imageControl: ElementRef<HTMLInputElement>;

  editMode: boolean;
  runtimeMode: boolean;
  private defaultImageSource = 'https://files.topo.ai/images/email/email-header-sit-report.png';
  imageSource = this.defaultImageSource;
  title: string;

  constructor(private translateService: TranslateService, private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    let settings = this.control?.settings as ImageElementSettings;

    this.title = this.templateDesignerService.getTranslateText(settings?.title, this._culture);

    if (!!!settings) {
      const control = produce(this.control, draftState => {
        if (!!!draftState.settings) {
          draftState.settings = {
            imageUrl: this.defaultImageSource,
            title: {}
          } as ImageElementSettings;
        }
      });

      this.control = control;

      this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
    }
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;

    const settings: ImageElementSettings = this.control?.settings;

    if (!!settings?.imageUrl) {
      this.imageSource = settings.imageUrl;
    } else {
      this.imageSource = this.defaultImageSource;
    }

    this.title = this.templateDesignerService.getTranslateText(settings?.title, this._culture);
  }

  onUploadClick(): void {
    this.uploadFileControl.nativeElement.click();
  }

  fileControlChanged($event) {
    $event.preventDefault();
    $event.stopPropagation();

    const files: FileList = $event.target.files;
    const file = files.length > 0 ? files[0] : null;

    if (!!file) {
      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          // convert image file to base64 string
          const imageData = reader.result as string;

          const control = produce(this.control, draftState => {
            if (!!!draftState.settings) {
              draftState.settings = {
                imageUrl: {},
                title: {}
              } as ImageElementSettings;
            }
            draftState.settings.imageUrl = imageData
          });

          this.control = control;

          if (!!control.settings?.imageUrl) {
            this.imageSource = control.settings.imageUrl;
          } else {
            this.imageSource = this.defaultImageSource;
          }

          this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
        },
        false
      );

      reader.readAsDataURL(file);
    }
  }

  edit(): void {
    this.onUploadClick();
  }

  setRuntimeData(value: any) {
    this.runtimeMode = true;
    if (!this.editMode && !!value) {
      const settings = value as ImageElementSettings;

      if (!!settings?.imageUrl) {
        this.imageSource = settings.imageUrl;
      } else {
        this.imageSource = this.defaultImageSource;
      }

      const control = produce(this.control, draftState => {
        if (!!!draftState.settings) {
          draftState.settings = {
            imageUrl: {},
            title: {}
          } as ImageElementSettings;
        }
        draftState.settings.imageUrl = this.imageSource;
      });

      this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
    }
  }

  titleChanged(value: any): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          imageUrl: {},
          title: {}
        } as ImageElementSettings;
      }
      if (!!!draftState.settings.title) {
        draftState.settings.title = {};
      }
      draftState.settings.title[this._culture] = value;

      if (!!!draftState.settings.imageUrl) {
        draftState.settings.imageUrl = this.defaultImageSource;
      }
    });

    this.control = control;

    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }
}
